module.exports = __webpack_public_path__ + "img/三一汽车制造有限公司.f140e064.jpg";